import { NavLink } from 'react-router-dom';
import {
  Autocomplete,
  IconAlternativeSandWatch,
  IconBlock,
  IconSelected,
  Select,
} from '@ui/src';
import ROUTES from '../../routes';
import { StatusTitle } from '../cash-collection/types';
import { UploadedTransactionGeneralTypes } from './types';

import cn from './styles.module.css';

const UploadedTransactionsGeneral = ({
  importItem,
}: UploadedTransactionGeneralTypes) => (
  <div className={cn.uploadedTransactionsGeneral}>
    <div className={cn.uploadedTransactionsGeneralStatusWrapper}>
      <div className={cn.uploadedTransactionsGeneralStatusIcon}>
        {importItem?.status === 'ACCEPTED' && <IconSelected />}
        {(importItem?.status === 'REJECTED' ||
          importItem?.status === 'AML_REJ') && <IconBlock />}
        {importItem?.status !== 'REJECTED' &&
          importItem?.status !== 'AML_REJ' &&
          importItem?.status !== 'ACCEPTED' && (
            <IconAlternativeSandWatch width={18} height={18} />
          )}
      </div>
      <div className={cn.uploadedTransactionsGeneralStatus}>
        {/* @ts-ignore */}
        {StatusTitle[importItem?.status as StatusTitle]}
      </div>
    </div>
    <div className={cn.uploadedTransactionGeneralInfo}>
      <div className={cn.uploadedTransactionGeneralInfoItem}>
        <div className={cn.uploadedTransactionGeneralInfoItemTitle}>
          {importItem?.beneficiariesCount?.all !== null
            ? importItem?.beneficiariesCount?.all
            : '-'}
        </div>
        <div className={cn.uploadedTransactionGeneralInfoItemDescription}>
          Number of <br /> transactions
        </div>
      </div>
      <div className={cn.uploadedTransactionGeneralInfoItem}>
        <div className={cn.uploadedTransactionGeneralInfoItemTitle}>
          {importItem?.beneficiariesCount?.proc !== null
            ? importItem?.beneficiariesCount?.proc
            : '-'}
        </div>
        <div className={cn.uploadedTransactionGeneralInfoItemDescription}>
          Not <br />
          processed
        </div>
      </div>
      <div className={cn.uploadedTransactionGeneralInfoItem}>
        <div className={cn.uploadedTransactionGeneralInfoItemTitle}>
          {importItem?.beneficiariesCount?.accepted !== null
            ? importItem?.beneficiariesCount?.accepted
            : '-'}
        </div>
        <div className={cn.uploadedTransactionGeneralInfoItemDescription}>
          Processed <br /> successfully
        </div>
      </div>
      <div className={cn.uploadedTransactionGeneralInfoItem}>
        <div className={cn.uploadedTransactionGeneralInfoItemTitle}>
          {importItem?.beneficiariesCount?.rejected !== null
            ? importItem?.beneficiariesCount?.rejected
            : '-'}
        </div>
        <div className={cn.uploadedTransactionGeneralInfoItemDescription}>
          Error <br /> processed
        </div>
      </div>
    </div>
    <div className={cn.formGroup}>
      <Select
        name="pspPartnerId"
        value={importItem?.pspPartnerId}
        title="Partner Bank"
        list={
          importItem?.pspPartnerId
            ? [
                {
                  name: importItem?.pspPartner?.companyName,
                  value: importItem?.pspPartner?.id,
                },
              ]
            : []
        }
        placeholder="Select partner bank"
        disabled
        fullWidth
      />
    </div>
    <div className={cn.formGroup}>
      <Autocomplete
        name="pspPartnerAccountId"
        value={importItem?.pspPartnerAccountId}
        title="Partner Bank Account"
        list={
          importItem?.pspPartnerAccountId
            ? [
                {
                  name: importItem?.pspPartnerAccount?.description,
                  value: importItem?.pspPartnerAccount?.id,
                  suffix: importItem?.pspPartnerAccount?.fullNumber,
                },
              ]
            : []
        }
        placeholder="Select partner bank account"
        disabled
        withSuffix
        fullWidth
      />
    </div>
    <div className={cn.separator} />
    <NavLink
      to={`${ROUTES.INCOMING}?paymentOrderId=${importItem?.id}`}
      className={cn.incomingTransactionsLink}
      target="_blank"
    >
      Open transactions from the order
    </NavLink>
  </div>
);

export default UploadedTransactionsGeneral;
